/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bodymap_Type_LigamentInputs */

const en_us2_bodymap_type_ligament = /** @type {(inputs: Bodymap_Type_LigamentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ligament`)
};

const pt_br2_bodymap_type_ligament = /** @type {(inputs: Bodymap_Type_LigamentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ligamento`)
};

const es_419_bodymap_type_ligament = /** @type {(inputs: Bodymap_Type_LigamentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ligamento`)
};

const pt_pt2_bodymap_type_ligament = /** @type {(inputs: Bodymap_Type_LigamentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ligamento`)
};

const fr_fr2_bodymap_type_ligament = /** @type {(inputs: Bodymap_Type_LigamentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ligament`)
};

const de_de2_bodymap_type_ligament = /** @type {(inputs: Bodymap_Type_LigamentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Band`)
};

const it_it2_bodymap_type_ligament = /** @type {(inputs: Bodymap_Type_LigamentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legamento`)
};

/**
* | output |
* | --- |
* | "Ligament" |
*
* @param {Bodymap_Type_LigamentInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const bodymap_type_ligament = /** @type {((inputs?: Bodymap_Type_LigamentInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bodymap_Type_LigamentInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_bodymap_type_ligament(inputs)
	if (locale === "es-419") return es_419_bodymap_type_ligament(inputs)
	if (locale === "pt-PT") return pt_pt2_bodymap_type_ligament(inputs)
	if (locale === "fr-FR") return fr_fr2_bodymap_type_ligament(inputs)
	if (locale === "de-DE") return de_de2_bodymap_type_ligament(inputs)
	if (locale === "it-IT") return it_it2_bodymap_type_ligament(inputs)
	return en_us2_bodymap_type_ligament(inputs)
});
export { bodymap_type_ligament as "bodymap.type.ligament" }